import { render, staticRenderFns } from "./AvailablePlans.vue?vue&type=template&id=5e2c0a36&scoped=true&"
import script from "./AvailablePlans.vue?vue&type=script&lang=ts&"
export * from "./AvailablePlans.vue?vue&type=script&lang=ts&"
import style0 from "./AvailablePlans.vue?vue&type=style&index=0&id=5e2c0a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c0a36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e2c0a36', component.options)
    } else {
      api.reload('5e2c0a36', component.options)
    }
    module.hot.accept("./AvailablePlans.vue?vue&type=template&id=5e2c0a36&scoped=true&", function () {
      api.rerender('5e2c0a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/AvailablePlans.vue"
export default component.exports